import React from "react";

/**
 * UsersTable — registered users with Mark / Refund Lifetime admin actions.
 */
export default function UsersTable({ users, onMarkLifetime, onRefundLifetime }) {
  return (
    <table className="w-full">
      <thead className="bg-white/5">
        <tr>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Name</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Email</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Subscription</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Joined</th>
          <th className="text-left p-4 text-[#E8E4DC] text-sm">Actions</th>
        </tr>
      </thead>
      <tbody>
        {users.map((u) => (
          <tr key={u.user_id} className="border-t border-white/10">
            <td className="p-4 text-white text-sm">{u.name}</td>
            <td className="p-4 text-[#E8E4DC] text-sm">{u.email}</td>
            <td className="p-4 text-[#A3E635] capitalize text-sm">{u.subscription_tier}</td>
            <td className="p-4 text-[#E8E4DC] text-sm">{new Date(u.created_at).toLocaleDateString()}</td>
            <td className="p-4">
              {u.subscription_tier === "lifetime" ? (
                <div className="flex items-center gap-2">
                  <span className="text-[#A3E635] text-xs font-bold uppercase tracking-wide">Lifetime</span>
                  <button
                    onClick={() => onRefundLifetime(u.email)}
                    className="text-xs font-semibold px-2.5 py-1 rounded-full bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-500/30 transition-colors"
                    data-testid={`refund-lifetime-${u.user_id}`}
                    title="Refund / revoke lifetime (chargeback)"
                  >
                    Refund
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => onMarkLifetime(u.email)}
                  className="text-xs font-semibold px-3 py-1.5 rounded-full bg-[#A3E635]/15 text-[#A3E635] hover:bg-[#A3E635]/25 border border-[#A3E635]/30 transition-colors"
                  data-testid={`mark-lifetime-${u.user_id}`}
                  title="Manually grant lifetime (admin)"
                >
                  Mark Lifetime
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
